<era-master-detail flexGrowLeft="2"
                   flexGrowRight="3">
  <era-master>
    <era-panel>
      <era-panel-header>
        <era-title>
          <span title
                i18n>Groups</span>
          <era-context-menu [isEditing]="editEnabled()"
                            (selectedEdit)="toggleEdit()"
                            canEdit="true">
            <button ngbDropdownItem
                    [routerLink]="['./permissions']">Permissions</button>
            <button ngbDropdownItem
                    (click)="addGroup()">Add group</button>
          </era-context-menu>
        </era-title>
        <div class="border-bottom"></div>
      </era-panel-header>
      <div class="list-group list-group-flush">
        @for (group of groups(); track group) {
          <era-group-list-item [group]="group"
                               [isEditing]="editEnabled()"
                               [routerLink]="group.id"
                               (deleteRequested)="deleteRequested.emit($event)"></era-group-list-item>
        }
      </div>
    </era-panel>
  </era-master>
</era-master-detail>